import React from 'react'
import { NextSeo } from 'next-seo'
import { isEqual } from 'lodash-es'

import type { NextSeoProps } from 'next-seo'

import { useCanonicalHref } from '@/hooks/routes'

export interface ISeoProps extends NextSeoProps {}

function Seo(props: ISeoProps) {
  const [canonicalHref] = useCanonicalHref()

  return <NextSeo canonical={canonicalHref} {...props} />
}

const WrappedSeo = React.memo(Seo, isEqual)

/**
 * 如果不自定义 propsAreEqual 函数，每次副作用导致的更新都会导致 NextSeo 更新操作，
 * NextSeo 内部应该没有做这种优化，故在项目内实现。
 */
export default WrappedSeo
